import md5 from 'md5';

export function generateMD5(input: string): string {
  const hash = md5(input.toString());
  return hash;
}